<div class="page-title-area">
    <img src="assets/images/casestudy_banner.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2>Success Stories</h2>
            <p class="page-title-content-text">Superior Digital Private Limited is your trusted Apple Authorised Reseller. Receive expert advice on Apple products and accessories. We offer MDM solutions, Apple Business Manager for Automated Device Enrolment, Zero Touch Deployment, flexible financial options, and ongoing managed services. Enjoy configuration and deployment services for immediate use.</p>        </div>
    </div>
</div>

<section class="home-case pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <!-- <span>Success Stories</span> -->
            <h2>Have a Look at Our Work Showcase</h2>
        </div>
        <div class="case">


            <div class="case-study-section">
              <!--   <div class="section-header">
                    <h3>Our Recent Case Studies</h3>
                    <p>Explore how we've helped businesses achieve their goals with innovative Apple solutions.</p>
                </div> --> 
                <div class="case-study-list">
                    <div class="case-study-item">
                        <h2>Vision Solutions</h2>
                        <div class="image-container">
                            <img src="assets/images/vision_img.png" alt="Essilor" class="case-study-img">
                            <div class="image-overlay">
                                <h4>Digital Transformation</h4>
                                <p>The integration of iPads has significantly improved the efficiency and effectiveness of Organisation's sales strategies.</p>
                                <a href="/essilor" class="read-more">Read Story</a>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="case-study-item">
                        <h2>Healthcare & Medical Technology</h2>
                        <div class="image-container">
                            <img src="assets/images/healthcare_img.png" alt="Remidio" class="case-study-img">
                            <div class="image-overlay">
                                <h4>iPhone Deployment</h4>
                                <p>The deployment of iPhones ensured consistent performance, with seamless post-sales support and guaranteeing uninterrupted operation.</p>
                                <a href="/remidio" class="read-more">Read Story</a>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="case-study-item">
                        <h2>Pharmaceutical & Medical Manufacturing</h2>
                        <div class="image-container">
                            <img src="assets/images/pharma_img.png" alt="WestPharma" class="case-study-img">
                            <div class="image-overlay">
                                <h4>iPad & iPhone Deployment</h4>
                                <p>The introduction of iPads and iPhones led to a 30% increase in sales interactions. The technology enhanced communication, improved workflows.</p>
                                <a href="/westpharma" class="read-more">Read Story</a>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="case-study-item">
                        <h2>Higher Education</h2>
                        <div class="image-container">
                            <img src="assets/images/high_edu_1.png" alt="msrit_ss" class="case-study-img">
                            <div class="image-overlay">
                                <h4>Technology Institute</h4>
                                <p>The establishment of the MacLab led to a significant increase in student engagement and productivity.</p>
                                <a href="/msrit" class="read-more">Read Story</a>
                            </div>
                        </div>
                        <br>
                        <div class="image-container">
                            <img src="assets/images/high_edu_2.png" alt="jain_ss" class="case-study-img">
                            <div class="image-overlay">
                                <h4>University</h4>
                                <p>The installation was completed within the scheduled timeframe, with all iMacs fully operational.</p>
                                <a href="/jain" class="read-more">Read Story</a>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="case-study-item">
                        <h2>Real Estate & Construction</h2>
                        <div class="image-container">
                            <img src="assets/images/real_est_img.png" alt="Construction" class="case-study-img">
                            <div class="image-overlay">
                                <h4>Builder's of Homes & Commercial Spaces</h4>
                                <p>The adoption of digital tools, including the use of iPads for immersive presentations, resulted in improved operational efficiency.</p>
                                <a href="/sowparnika" class="read-more">Read Story</a>
                            </div>
                        </div>
                    </div>
                    <hr>

                </div>
            </div>
            <!-- <div class="tabs-container">
                <div class="pane" id="tab1" *ngIf="currentTab === 'tab1'">
                    <div class="row case-list">
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/essilor"><img src="assets/images/case/ca6.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/essilor"><h3>Essilor's Digital Transformation</h3></a>
                                    <p>The integration of iPads has significantly improved the efficiency and effectiveness of Essilor's sales strategies.</p>
                                    <a routerLink="/essilor" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/remidio"><img src="assets/images/case/ca1.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/remidio"><h3>Remidio</h3></a>
                                    <p>The deployment of iPhones ensured consistent performance, with seamless post-sales support and guaranteeing uninterrupted operation.</p>
                                    <a routerLink="/remidio" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/westpharma"><img src="assets/images/case/ca2.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/westpharma"><h3>WestPharma</h3></a>
                                    <p>The introduction of iPads and iPhones led to a 30% increase in sales interactions. The technology enhanced communication, improved workflows.</p>
                                    <a routerLink="/westpharma" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/msrit"><img src="assets/images/case/ca3.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/msrit"><h3>MSRIT</h3></a>
                                    <p>The establishment of the MacLab led to a significant increase in student engagement and productivity.</p>
                                    <a routerLink="/msrit" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/jain"><img src="assets/images/case/ca4.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/jain"><h3>Jain University</h3></a>
                                    <p>The installation was completed within the scheduled timeframe, with all iMacs fully operational.</p>
                                    <a routerLink="/jain" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/sowparnika"><img src="assets/images/case/ca5.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/sowparnika"><h3>Sowparnika Homes</h3></a>
                                    <p>The adoption of digital tools, including the use of iPads for immersive presentations, resulted in improved operational efficiency.</p>
                                    <a routerLink="/sowparnika" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</section>

<!-- <div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div> -->